import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';
import { FileLockProp, InvoiceBillCrdb } from '../ifmsTypes';
import _ from 'lodash';

export class BtOrder extends TrackableEntity {
    id: number = 0;
    orderNo: string = '';
    billTo: number = 0;
    billToName: string = '';
    shipper: number = 0;
    shipperName: string = '';
    puLoc: number = 0;
    puLocName: string = '';
    origin: number = 0;
    originName: string = '';
    originPort: string = '';
    originCityState: string ='';
    dest: number = 0;
    destName: string = '';
    departure: string | null = null;
    destPort: string = '';
    destCityState: string = '';
    departed: boolean = false;
    arrival: string | null = null;
    arrived: boolean = false;
    arrivalNote: string = '';
    remark: string = '';
    pkgs: number = 0;
    punit: string = '';
    kgs: number = 0;
    lbs: number = 0;
    cbm: number = 0;
    cft: number = 0;
    marks: string = '';
    commodity: string = '';
    custRefNo: string = '';
    mblNo: string = '';
    hblNo: string = '';
    uCnee: number = 0;
    uCneeName: string = '';
    miscRefNo: string = '';
    vessel: string = '';
    eta: string | null = null;
    cntrNo: string = '';
    cntrType: string = '';
    availDate: string | null = null;
    lastFree: string | null = null;
    emptyReturn: string | null = null;
    oblRcvd: boolean = false;
    cClear: boolean = false;
    itNo: string = '';
    itNo2: string = '';
    itDate: string | null = null;
    itDate2: string | null = null;
    bondIssuer: number = 0;
    bondIssuerName: string = '';

    fileClosed: number = 0;
    closed: boolean = false;
    closedBy: string = '';
    closeDate: string | null = null;
    u1Id: string = '';
    u1Date: string | null = null;
    u2Id: string = '';
    u2Date: string | null = null;
    isClosed: boolean = false;

    profitShare: number = 0;
    invoiceBill: InvoiceBillCrdb|null = null;
    actClosed: boolean = false;
    actClosedBy: string = '';
    actCloseDate: string | null = null;

    confirmDate: string | null = null;
    confirmedBy: string = '';

    statusInvo: string = '';
    statusBill: string = '';
    statusCrdb: string = '';
    
    completeBill: string = '';
    completeInvo: string = '';
    completeCrdb: string = '';

    itNoValid: boolean = false;
    itNoValid2: boolean = false;

    instruct: string = '';
    amsblNo: string = '';
    isfNo: string = '';
    orderDate: string | null = null;

    useAms: boolean = false;
    useIsf: boolean = false;
    chbRspCode: string = '';
    chbRspMsg: string = '';

    projectNo: string = '';
    loadNo: string = '';
    doNo: string = '';
    loadId: number = 0;
    doId: number = 0;

    draft: boolean = true;
    trackingNo: string = '';
    sharedURL: string = '';

    loadingPort: string ='';
    etd: string | null = null;
    sealNo: string = '';

    showIQ: boolean = false;

    mot: string = '';
    pl: boolean = false;
    ci: boolean = false;
    fmot: string = '';
    appoint: string = '';
    dlvDate: string = '';
    fDest: string = '';
    feta: string|null = null;
    anIssuer: number = 0;
    anIssuerName: string = '';
    orderSource: number = 0;
    orderSourceName: string = '';

    // For RtdShipInfo
    shipmentId: string = '';
    shipFrom: string = '';
    shipTo: string = '';
    departureUtc: string | null = null;
    fromTZOffset: number = 0;
    currentLoc: string = '';
    etaUtc: string | null = null;
    currentEtaUtc: string | null = null;
    toTZOffset: number = 0;
    distanceLeft: number = 0;
    completedUtc: string | null = null;


    completed: boolean = false;

    isFileLockFor(propName: string) {
        return this.isClosed && !BtOrder.fileLockEnableProps.some(x => x.key === propName);
    }

    static getFileLockMessage(): string {
        return 'Op Close';
    }
    
    static fileLockEnableProps: FileLockProp[] = [
        { key: '', name: '' },
    ];

    constructor(init?:Partial<BtOrder>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id', 'invoiceBill','closedDate','actClosed','actClosedBy','actCloseDate', 'showIQ', 'useIsf');
        this.getdateProps.push('u1Date', 'u2Date'); 
        if(this.id === 0) this.id = this.GetNextId();

    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        const dicFieldMap:IDictionary<DBMappingInfo> = {};
        _.keys(BtOrder.dicFieldMappings).forEach(m=>{
            dicFieldMap[m] = BtOrder.dicFieldMappings[m];
        });


        return dicFieldMap;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'orderNo': new DBMappingInfo({ field: 'F_OrderNo', table: 'T_BTOrder' }),
        'billTo': new DBMappingInfo({ field: 'F_BillTo', table: 'T_BTOrder' }),
        'shipper': new DBMappingInfo({ field: 'F_Shipper', table: 'T_BTOrder' }),
        'puLoc': new DBMappingInfo({ field: 'F_PuLoc', table: 'T_BTOrder' }),
        'origin': new DBMappingInfo({ field: 'F_Origin', table: 'T_BTOrder' }),
        'dest': new DBMappingInfo({ field: 'F_Dest', table: 'T_BTOrder' }),
        'departure': new DBMappingInfo({ field: 'F_Departure', table: 'T_BTOrder' }),
        'departed': new DBMappingInfo({ field: 'F_Departed', table: 'T_BTOrder' }),
        'arrival': new DBMappingInfo({ field: 'F_Arrival', table: 'T_BTOrder' }),
        'arrived': new DBMappingInfo({ field: 'F_Arrived', table: 'T_BTOrder' }),
        'arrivalNote': new DBMappingInfo({ field: 'F_ArrivalNote', table: 'T_BTOrder' }),
        'remark': new DBMappingInfo({ field: 'F_Remark', table: 'T_BTOrder' }),
        'pkgs': new DBMappingInfo({ field: 'F_Pkgs', table: 'T_BTOrder' }),
        'punit': new DBMappingInfo({ field: 'F_PUnit', table: 'T_BTOrder' }),
        'kgs': new DBMappingInfo({ field: 'F_Kgs', table: 'T_BTOrder' }),
        'lbs': new DBMappingInfo({ field: 'F_Lbs', table: 'T_BTOrder' }),
        'cbm': new DBMappingInfo({ field: 'F_Cbm', table: 'T_BTOrder' }),
        'cft': new DBMappingInfo({ field: 'F_Cft', table: 'T_BTOrder' }),
        'marks': new DBMappingInfo({ field: 'F_Marks', table: 'T_BTOrder' }),
        'commodity': new DBMappingInfo({ field: 'F_Commodity', table: 'T_BTOrder' }),
        'custRefNo': new DBMappingInfo({ field: 'F_CustRefNo', table: 'T_BTOrder' }),
        'mblNo': new DBMappingInfo({ field: 'F_MblNo', table: 'T_BTOrder' }),
        'hblNo': new DBMappingInfo({ field: 'F_HblNo', table: 'T_BTOrder' }),
        'uCnee': new DBMappingInfo({ field: 'F_UCnee', table: 'T_BTOrder' }),
        'miscRefNo': new DBMappingInfo({ field: 'F_MiscRefNo', table: 'T_BTOrder' }),
        'vessel': new DBMappingInfo({ field: 'F_Vessel', table: 'T_BTOrder' }),
        'eta': new DBMappingInfo({ field: 'F_ETA', table: 'T_BTOrder' }),
        'cntrNo': new DBMappingInfo({ field: 'F_CntrNo', table: 'T_BTOrder' }),
        'cntrType': new DBMappingInfo({ field: 'F_CntrType', table: 'T_BTOrder' }),
        'availDate': new DBMappingInfo({ field: 'F_AvailDate', table: 'T_BTOrder' }),
        'lastFree': new DBMappingInfo({ field: 'F_LastFree', table: 'T_BTOrder' }),
        'emptyReturn': new DBMappingInfo({ field: 'F_EmptyReturn', table: 'T_BTOrder' }),
        'oblRcvd': new DBMappingInfo({ field: 'F_OblRcvd', table: 'T_BTOrder' }),
        'cClear': new DBMappingInfo({ field: 'F_CClear', table: 'T_BTOrder' }),
        'itNo': new DBMappingInfo({ field: 'F_ITNo', table: 'T_BTOrder' }),
        'itDate': new DBMappingInfo({ field: 'F_ITDate', table: 'T_BTOrder' }),
        'itNo2': new DBMappingInfo({ field: 'F_ITNo2', table: 'T_BTOrder' }),
        'itDate2': new DBMappingInfo({ field: 'F_ITDate2', table: 'T_BTOrder' }),
        'bondIssuer': new DBMappingInfo({ field: 'F_BondIssuer', table: 'T_BTOrder' }),
        'fileClosed': new DBMappingInfo({ field: 'F_FileClosed', table: 'T_BTOrder' }),
        'closedBy': new DBMappingInfo({ field: 'F_ClosedBy', table: 'T_BTOrder' }),
        'closeDate': new DBMappingInfo({ field: 'F_CloseDate', table: 'T_BTOrder' }),
        'u1Id': new DBMappingInfo({ field: 'F_U1Id', table: 'T_BTOrder' }),
        'u1Date': new DBMappingInfo({ field: 'F_U1Date', table: 'T_BTOrder' }),
        'u2Id': new DBMappingInfo({ field: 'F_U2Id', table: 'T_BTOrder' }),
        'u2Date': new DBMappingInfo({ field: 'F_U2Date', table: 'T_BTOrder' }),
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_BTOrder' }),
        'itNoValid': new DBMappingInfo({ field: 'F_ITNoValid', table: 'T_BTOrder' }),
        'itNoValid2': new DBMappingInfo({ field: 'F_ITNoValid2', table: 'T_BTOrder' }),
        'instruct': new DBMappingInfo({ field: 'F_Instruct', table: 'T_BTOrder' }),
        'amsblNo': new DBMappingInfo({field: 'F_AmsBLNo', table: 'T_BTOrder'}),
        'isfNo': new DBMappingInfo({field:'F_IsfNo', table: 'T_BTOrder'}),
        'orderDate': new DBMappingInfo({field:'F_OrderDate', table: 'T_BTOrder'}),
        'useAms': new DBMappingInfo({ field: 'F_UseAms', table: 'T_BTOrder' }),
        'useIsf': new DBMappingInfo({ field: 'F_UseIsf', table: 'T_BTOrder' }),
        'chbRspCode': new DBMappingInfo({ field: 'F_CHBRspCode', table: 'T_BTOrder' }),
        'chbRspMsg': new DBMappingInfo({ field: 'F_CHBRspMsg', table: 'T_BTOrder' }),
        'projectNo': new DBMappingInfo({ field: 'F_ProjectNo', table: 'T_BTOrder' }),
        'draft': new DBMappingInfo({field:'F_Draft', table: 'T_BTOrder'}),
        'trackingNo': new DBMappingInfo({field:'F_TrackingNo', table: 'T_BTOrder'}),
        'shipmentId': new DBMappingInfo({field:'F_SharedURL', table: 'T_BTOrder'}),
    'loadingPort': new DBMappingInfo({field: 'F_LoadingPort', table: 'T_BTOrder'}),
        'sealNo': new DBMappingInfo({field: 'F_SealNo', table: 'T_BTOrder'}),
        'etd': new DBMappingInfo({field: 'F_ETD', table: 'T_BTOrder'}),
        'mot': new DBMappingInfo({field:'F_MOT', table:'T_BTOrder'}),
        'pl': new DBMappingInfo({field:'F_Pl', table : 'T_BTOrder'}),
        'ci': new DBMappingInfo({field:'F_Ci', table : 'T_BTOrder'}),
        'fmot': new DBMappingInfo({field:'F_FMOT', table:'T_BTOrder'}),
        'appoint': new DBMappingInfo({field:'F_Appoint', table: 'T_BTOrder'}),
        'dlvDate': new DBMappingInfo({field: 'F_DlvDate', table:'T_BTOrder'}),
        'fDest': new DBMappingInfo({field:'F_FDest', table:'T_BTOrder'}),
        'feta': new DBMappingInfo({field: 'F_FETA', table: 'T_BTOrder'}),
        'completed': new DBMappingInfo({ field: 'F_Completed', table: 'T_BTOrder' }),
        'anIssuer': new DBMappingInfo({field: 'F_ANIssuer', table: 'T_BTOrder'}),
        'orderSource': new DBMappingInfo({field: 'F_OrderSource', table: 'T_BTOrder'}),
    };
}
